export function formatTrimmedCheck() {
  return "string must be trimmed";
}
